export default "__VITE_ASSET__q_Csr3Re__"